import React, { useState, useEffect } from 'react';
import './ValentineBanner.css';
import photo from "../../../../shared/ui/img/photo.jpg"
import photo1 from "../../../../shared/ui/img/photo1.jpg"
import photo2 from "../../../../shared/ui/img/photo2.jpg"
import photo3 from "../../../../shared/ui/img/photo3.jpg"

const imageList = [photo, photo2, photo3, photo1];

export const ValentineBanner = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Расчет оставшегося времени до 14 февраля следующего года
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const currentYear = now.getFullYear();
      const valentinesDay = new Date(currentYear, 1, 14); // 14 февраля текущего года

      const difference = valentinesDay.getTime() - now.getTime();

      if (difference > 0 ) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleButtonClick = () => {
    console.log('Переход к выбору букетов');
    // todo открыть попап?
  };

  return (
    <div className="valentine-banner">
      <div className="valentine-banner__content">
        <div className="valentine-banner__text-content">
          <h3 className="valentine-banner__heading">
            Ваше «Люблю» заслуживает самого красивого перевода.
          </h3>

          <p className="valentine-banner__subheading">
            Идеальные цветы для 14 февраля. Создаем романтические букеты, которые скажут всё за вас.
          </p>

          {!!timeLeft.minutes && (
          <div className="valentine-banner__countdown-timer">
            <div className="timer-title">До 14 февраля осталось:</div>
            <div className="timer-digits">
              <div className="time-block">
                <span className="time-number">{timeLeft.days.toString().padStart(2, '0')}</span>
                <span className="time-label">дней</span>
              </div>
              <div className="time-separator">:</div>
              <div className="time-block">
                <span className="time-number">{timeLeft.hours.toString().padStart(2, '0')}</span>
                <span className="time-label">часов</span>
              </div>
              <div className="time-separator">:</div>
              <div className="time-block">
                <span className="time-number">{timeLeft.minutes.toString().padStart(2, '0')}</span>
                <span className="time-label">минут</span>
              </div>
              <div className="time-separator">:</div>
              <div className="time-block">
                <span className="time-number">{timeLeft.seconds.toString().padStart(2, '0')}</span>
                <span className="time-label">секунд</span>
              </div>
            </div>
          </div>
          )}

          <div
            className="valentine-banner__masonry"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
              gap: '16px',
              margin: '20px 0',
            }}
          >
            {imageList.map((img, index) => (
              <div key={`item-${index}`} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                <img
                  src={img}
                  alt={`Букет ко дню святого Валентина ${index + 1}`}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          <a href="tel:+79872588111">
                    <button
                      className="valentine-banner__button"
                      onClick={handleButtonClick}
                      aria-label="Выбрать букет ко Дню святого Валентина"
                    >
                      Выбрать идеальный букет
                    </button>
                    </a>
          <p className="valentine-banner__hint-text">
            Забронируйте заранее и получите открытку c признанием в подарок
          </p>
        </div>
      </div>
    </div>
  );
};
